import React from 'react';
import { Pause, Play, Volume2, VolumeX, Trash2 } from 'lucide-react';

/**
 * Controls — main interaction buttons: pause/resume detection, mute TTS, clear.
 */
export default function Controls({ appState, muted, onPauseResume, onToggleMute, onClear, hasHistory }) {
  const isLive = appState === 'running' || appState === 'paused';
  const isPaused = appState === 'paused';

  return (
    <div className="sv-card p-4 sm:p-5" data-testid="controls-card">
      <div className="flex items-center justify-between mb-3">
        <p className="sv-eyebrow">Controls</p>
      </div>
      <div className="grid grid-cols-2 gap-3" data-testid="controls-grid">
        <button
          className={`sv-ctrl-btn ${isPaused ? 'sv-ctrl-btn--accent' : ''}`}
          onClick={onPauseResume}
          disabled={!isLive}
          data-testid="pause-resume-btn"
          title={isPaused ? 'Resume detection' : 'Pause detection'}
        >
          {isPaused ? <Play className="w-4 h-4" /> : <Pause className="w-4 h-4" />}
          <span>{isPaused ? 'Resume' : 'Pause'}</span>
        </button>

        <button
          className={`sv-ctrl-btn ${muted ? 'sv-ctrl-btn--muted' : ''}`}
          onClick={onToggleMute}
          data-testid="mute-btn"
          title={muted ? 'Enable voice' : 'Mute voice'}
        >
          {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
          <span>{muted ? 'Voice Off' : 'Voice On'}</span>
        </button>

        <button
          className="sv-ctrl-btn col-span-2"
          onClick={onClear}
          disabled={!hasHistory}
          data-testid="clear-history-btn"
          title="Clear history"
        >
          <Trash2 className="w-4 h-4" />
          <span>Clear History</span>
        </button>
      </div>
    </div>
  );
}
